import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  computed,
  inject,
  signal,
} from '@angular/core';
import * as THREE from 'three';

// @ts-ignore - JS module without types
import { Utils } from '../shared/utils.js';
import { SceneStateService } from '../services/scene-state.service';
import { ViewerCoreService } from '../services/viewer-core.service';
import { onViewerEvents } from '../services/event-dispatcher-bridge';

@Component({
  selector: 'app-compass',
  imports: [CommonModule],
  templateUrl: './compass.component.html',
  styleUrls: ['./compass.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompassComponent implements OnInit, OnDestroy {
  @Input() viewer: any;
  @Input() visible = true;

  @ViewChild('compassImg', { static: false }) compassImg?: ElementRef<HTMLImageElement>;

  private core = inject(ViewerCoreService);
  private sceneState = inject(SceneStateService);
  private destroyRef = inject(DestroyRef);

  azimuthDegrees = signal(0);
  transformStyle = computed(() => `rotateZ(${this.azimuthDegrees()}deg)`);

  ngOnInit(): void {
    if (!this.viewer) {
      return;
    }

    const updateListener = (): void => {
      const view = this.sceneState.view();
      if (!view) return;
      const direction = view.direction.clone();
      direction.z = 0;
      direction.normalize();

      const camera = this.sceneState.getActiveCamera();
      if (!camera) return;
      const p1 = camera.getWorldPosition(new THREE.Vector3());
      const p2 = p1.clone().add(direction);

      const projection = this.viewer.getProjection();
      const azimuth = Utils.computeAzimuth(p1, p2, projection);

      this.azimuthDegrees.set((-azimuth * 180) / Math.PI);
    };

    onViewerEvents(this.viewer, { update: updateListener }, this.destroyRef);
  }

  ngOnDestroy(): void {
    // Cleanup handled by DestroyRef via onViewerEvents
  }

  onCompassClick(): void {
    if (this.viewer) {
      this.viewer.setTopView();
    }
  }
}
